"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER_CURATION_PORTAL_FACET_NAMES = exports.CURATION_PORTAL_FACET_NAMES = exports.PRINT_CURATION_PORTAL_FACET_NAMES = exports.COMMON_CURATION_PORTAL_FACET_NAMES = void 0;
exports.COMMON_CURATION_PORTAL_FACET_NAMES = {
    SORT: 'sort',
    CURATED_STATUS: 'curated_status_value',
    AVAILABILITY_STATUS: 'original_availability_status',
    CATEGORY: 'artwork_category',
    STYLES: 'styles',
    SUBJECT: 'subject',
    MEDIUMS: 'mediums',
    SIZE: 'size_bin',
    PRICE: 'geo_prices',
    ARTIST_COUNTRY: 'country',
    US_STATE: 'us_state',
    CITY: 'city',
    ORIENTATION: 'orientation',
    MATERIALS: 'materials',
    FEATURED_IN: 'artist_recognition',
    COLOR: 'color',
    READY_TO_HANG: 'is_ready_to_hang',
    FRAMED: 'is_framed',
    PANELS: 'panels',
    OUTDOOR_SAFE: 'is_outdoor_safe',
    PACKAGING: 'packaging',
    ARTIST_GENDER: 'artist_gender',
    ARTIST_ETHNICITY: 'artist_ethnicity',
};
exports.PRINT_CURATION_PORTAL_FACET_NAMES = {
    PRINT_MATERIAL: 'print_materials',
    PRINT_SIZE: 'print_size_bins',
    PRINT_ORIENTATION: 'print_orientations',
    PRINT_PRICE: 'print_all_prices_values',
    // PRINT_AVAILABILITY_STATUS: 'print_availability_status',
};
exports.CURATION_PORTAL_FACET_NAMES = Object.assign(Object.assign({}, exports.COMMON_CURATION_PORTAL_FACET_NAMES), exports.PRINT_CURATION_PORTAL_FACET_NAMES);
exports.OTHER_CURATION_PORTAL_FACET_NAMES = {
    CURATED_STATUS: 'curated_status',
};
